import { Directive, TemplateRef, inject } from '@angular/core';

/**
 * Projectable template for rendering a resource card (resource header in horizontal view
 * and resource row in vertical view).
 * Usage:
 * <ng-template beautySchedulerResource let-resource>
 *   <!-- custom markup using resource -->
 *   <div class="resource-custom">
 *     <strong>{{ resource.title }}</strong>
 *   </div>
 * </ng-template>
 */
@Directive({
  selector: 'ng-template[beautyappSchedulerResource]',
  standalone: true
})
export class BeautySchedulerResourceTemplateDirective {
  readonly template = inject<TemplateRef<any>>(TemplateRef);
}
